import { FC } from "react";
import { NavLink } from "react-router-dom";

import { AppliaChildRoute } from "../../config/routes/routes";

interface PillarTopicsProps {
	children: AppliaChildRoute[];
	pillarUrl: string;
}

const PillarTopics: FC<PillarTopicsProps> = ({ children, pillarUrl }) => {
	return (
		<div className="mt-12 mb-8">
			<p className="uppercase text-sm font-semibold tracking-wide mb-4" style={{ color: "#999" }}>
				Topics in this pillar
			</p>
			<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
				{children.map((child) => (
					<NavLink
						key={child.url}
						to={`${pillarUrl}${child.url}`}
						className="block p-5 bg-white rounded-lg border hover:border-primary transition-colors"
						style={{ borderColor: "#dde3ec" }}
					>
						<p className="font-bold text-secondary mb-2">{child.label}</p>
						{child.description && (
							<p className="text-sm text-gray-500 leading-relaxed">{child.description}</p>
						)}
					</NavLink>
				))}
			</div>
		</div>
	);
};

export { PillarTopics };
